// extracted by mini-css-extract-plugin
module.exports = {"pressInfo":"PressInfo_pressInfo__142to","button":"PressInfo_button__3NeIb","info":"PressInfo_info__2WLtf","img":"PressInfo_img__oG0l6","perssInfo":"PressInfo_perssInfo__32c-B"};